import React, { useEffect, useState } from 'react'
import { marked } from 'marked'

import styles from './message.module.css'

import type { MessageProps } from './message.type'

export const Message = ({
  isFromHost,
  content,
  messageType,
  isLoading,
}: MessageProps) => {
  const [html, setHtml] = useState('')


  useEffect(() => {
    const parseMarkdown = async () => {
      const parsedHtml = await marked(content || '')
      setHtml(parsedHtml)
    }

    parseMarkdown()
  }, [content])

  const renderMessage = () => {
    if (messageType === 'text') {
      return (
        <React.Fragment>
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </React.Fragment>
      )
    }

    return content
  }

  return (
    <div className={`${styles.message} ${styles[isFromHost ? 'host' : 'user']}`}>
      {isLoading ? (
        <div className={styles.loading}>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
      ) : (
        renderMessage()
      )}
    </div>
  )
}
